<template>
  <b-container fluid class="no-sided-margin">

    <b-row class="margin-top-md margin-bottom-md">
      <b-col cols="2">
        <b-card header-bg-variant="light">
          <template #header>
            <div class="custom-card-header">
              <strong>
                <b-icon-funnel></b-icon-funnel>
                Filtri</strong>
            </div>
          </template>
          <b-card-body style="padding: 0.5rem">
            <b-form @submit="findFilteredUpdateInvoice">
              <b-form-group label="Stato">
                <b-form-radio-group v-model="statusFilter" buttons fluid>
                  <b-form-radio button-variant="outline-primary" value="NEW">Nuova</b-form-radio>
                  <b-form-radio button-variant="outline-primary" value="WIP">In Lavorazione</b-form-radio>
                  <b-form-radio button-variant="outline-primary" value="DONE">Risolta</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-button type="submit" variant="primary" block id="search">
                <b-icon-search/>&nbsp;Cerca
              </b-button>
              <b-button @click="exportCsv" variant="success" block>
                <b-icon-arrow-bar-down/>&nbsp;Download csv
              </b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="10">
        <b-card header-bg-variant="light">
          <template #header>
            <div style="height: 1.5rem">
              <span><strong><b-icon-card-checklist/>&nbsp;Pagamenti non effettuati </strong></span>
            </div>
          </template>
          <b-card-body v-show="unpaidInvoice.length > 0">
            <b-table sticky-header="71vh" :no-border-collapse="true" responsive :fields="fields" :items="unpaidInvoice">
              <template #cell(note)="data">
                <div v-b-popover.hover.top="data.item.note" title="Nota" class="text-truncate" style="max-width: 200px">
                  {{ data.item.note || 'Nessuna nota' }}
                </div>
              </template>
              <template #cell(status)="data">
                <b-dropdown size="sm" :disabled=false id="status-dropdown" dropright
                            :text=translateStatus(data.item.status) variant="outline-primary"
                            class="m-2" :variant="statusVariant(data.item.status)">
                  <b-dropdown-item @click="saveStatus(data.item, 'NEW')">NUOVA</b-dropdown-item>
                  <b-dropdown-item @click="saveStatus(data.item, 'WIP')">IN LAVORAZIONE</b-dropdown-item>
                  <b-dropdown-item @click="saveStatus(data.item, 'DONE')">RISOLTA</b-dropdown-item>
                </b-dropdown>
              </template>
              <template #cell(action)="data">
                <b-button-toolbar>
                  <b-button-group class="mr-2">
                    <b-button size="sm" title="Modifica le note" v-b-tooltip.hover variant="success" ref="note"
                              v-b-modal.noteModal @click="editNote(data.item)">
                      <b-iconstack>
                        <b-icon stacked icon="file"></b-icon>
                        <b-icon stacked icon="pencil-fill" scale="0.8" shift-h="5" shift-v="1"></b-icon>
                      </b-iconstack>
                    </b-button>
                    <b-button @click="data.toggleDetails" size="sm" title="Mostra dettaglo utente" v-b-tooltip.hover variant="info" ref="note">
                      <b-icon-book-half size="sm"/>
                    </b-button>
                  </b-button-group>
                </b-button-toolbar>
              </template>
              <template #row-details="data">
                <b-row class="mb-2">
                  <UserDetail :customerKey="data.item.key"/>
                </b-row>
              </template>

            </b-table>
          </b-card-body>
          <b-card-body v-show="unpaidInvoice.length === 0" class="text-center">
            <h1 style="padding-top: 25px">
              <b-icon-search/>
            </h1>
            <h3 style="padding-bottom: 25px">Nessun mancato addebito trovato</h3>
          </b-card-body>
        </b-card>
        <b-pagination
          v-if="unpaidInvoicesAmount>100"
          align="right"
          v-model="currentPage"
          @change="findUnpaidInvoice"
          :per-page="pageSize"
          :total-rows="unpaidInvoicesAmount"
        ></b-pagination>
      </b-col>
    </b-row>
    <ModalNote :note="invoiceNote" event-name="warning-note-edited" @warning-note-edited="saveNote"/>
  </b-container>
</template>

<script>
import Sensei from "@/api/AutoshopApi"
import moment from "moment/moment";
import customers from "@/views/Customers.vue";
import eventBus from "@/EventBus";
import ModalNote from "@/components/ModalNote.vue";
import UserDetail from "@/components/senseiAnagraphics/UserDetail.vue";

export default {
  name: 'UnpaidInvoice',
  components: {ModalNote, UserDetail},
  provide() {
    return {parentValidator: this.$validator}
  },
  mounted() {

    this.findUnpaidInvoice(this.currentPage)
  },


  data: () => ({
    fields: [
      {key: "storeKey", label: "Negozio"},
      {key: "timestamp", label: "Data tentativo"},
      {key: "key", label: "Codice cliente"},
      {key: "basketId", label: "Codice Carrello"},
      {key: "invoiceAmount", label: "Imp. fatturato"},
      {key: "outstandingAmount", label: "Imp. dovuto"},
      {key: "chargedAmount", label: "Imp. addebitato"},
      {key: "currency", label: "Valuta"},

      {key: "note", label: 'Note'},
      {key: "status", label: 'Stato'},
      {key: "action", label: ''}
    ],
    unpaidInvoice: [],
    customers,
    invoiceNote: null,
    statusFilter: null,
    effectiveStatusFilter: null,

    currentUnpaidInvoice: null,
    currentPage: 1,
    pageSize: 100,
    unpaidInvoicesAmount: 1,

  }),
  methods: {
    findFilteredUpdateInvoice(event){
      if (event) event.preventDefault()
      this.effectiveStatusFilter = this.statusFilter
      this.findUnpaidInvoice(this.currentPage)
    },
    findUnpaidInvoice(currentPage) {
      if(this.effectiveStatusFilter == null){
        Sensei.findAllUnpaidInvoices(currentPage, this.pageSize).then(result => this.fillUnpaidInvoice(result))}
      else{
        Sensei.findAllUnpaidInvoicesFiltered(this.effectiveStatusFilter, currentPage, this.pageSize).then(result => this.fillUnpaidInvoice(result))}
    },
    fillUnpaidInvoice(result) {
      this.unpaidInvoicesAmount = result.pageCount * this.pageSize
      result.unpaidInvoices.forEach(unpaidInvoice => {
        unpaidInvoice.timestamp = this.asISODate(unpaidInvoice.timestamp)
      })
      this.unpaidInvoice = result.unpaidInvoices
    },
    editNote(unpaidInvoice) {
      this.unpaidInvoice.note = unpaidInvoice.note
      this.currentUnpaidInvoice = unpaidInvoice
    },
    saveNote(data) {
      Sensei.setInfo(data.note, this.currentUnpaidInvoice.status, this.currentUnpaidInvoice.key, this.currentUnpaidInvoice.storeKey, this.currentUnpaidInvoice.basketId).then(() => {
        this.findUnpaidInvoice()
      })
    },
    saveStatus(data,status) {
      Sensei.setInfo(data.note,status, data.key, data.storeKey, data.basketId).then(() => {
        this.findUnpaidInvoice()
      })

    },
    membershipDetails(unpaidInvoice) {
      let unpaidInvoices = new Array(unpaidInvoice)
      eventBus.$emit('show-unpaidInvoiceDetails', unpaidInvoices)
    },
    exportCsv() {
      if(this.statusFilter == null){
        Sensei.downloadCsvUnpaidInvoices();
      }
      else{
        Sensei.downloadFilteredCsvUnpaidInvoices(this.statusFilter)
      }
    },
    translateStatus(status){
      switch (status){
        case 'NEW':
          return 'NUOVA'
        case 'WIP':
          return 'IN LAVORAZIONE'
        case 'DONE':
          return 'RISOLTA'
      }
    },
    statusVariant (status) {
      switch (status) {
        case 'NEW':
          return 'primary'
        case 'WIP':
          return 'warning'
        case 'DONE':
        case 'SENT':
          return 'success'
      }
    },
    asISODate: date => moment(date).format('DD/MM/YYYY HH:mm'),
  }
}
</script>

<style>
.general-map {
  width: 100%;
  height: 600px;
}

.single-user {
  width: 100%;
  height: 450px;
}
</style>
